"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es.array.push.js");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "inquiry-wrapper"
  }, [_c("el-row", {
    attrs: {
      gutter: 28
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      lg: 14
    }
  }, [_c("div", {
    staticClass: "form-card"
  }, [_c("div", {
    staticClass: "form-card__header"
  }, [_c("div", {
    staticClass: "form-card__header-dot"
  }), _c("h2", {
    staticClass: "form-card__title"
  }, [_vm._v(" New Lead ")]), _c("p", {
    staticClass: "form-card__subtitle"
  }, [_vm._v(" Fill in the details below to create a lead ")])]), _c("el-form", {
    ref: "formData",
    staticClass: "inquiry-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "top"
    }
  }, [_c("div", {
    staticClass: "form-section"
  }, [_c("div", {
    staticClass: "form-section__label"
  }, [_vm._v(" Client Information ")]), _c("el-row", {
    attrs: {
      gutter: 16
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Company"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      placeholder: "Select Company"
    },
    on: {
      change: _vm.onCompanyChange
    },
    model: {
      value: _vm.formData.companyId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "companyId", $$v);
      },
      expression: "formData.companyId"
    }
  }, _vm._l(_vm.companiesList, function (company) {
    return _c("el-option", {
      key: company.id,
      attrs: {
        label: company.name,
        value: company.id
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Client",
      prop: "clientId"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "remote-method": _vm.fetchClientList,
      filterable: "",
      clearable: "",
      "default-first-option": "",
      remote: "",
      placeholder: "Search Client",
      disabled: !_vm.formData.companyId || _vm.isEdit
    },
    on: {
      change: _vm.onClientChange
    },
    model: {
      value: _vm.formData.clientId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "clientId", $$v);
      },
      expression: "formData.clientId"
    }
  }, _vm._l(_vm.clientList, function (client) {
    return _c("el-option", {
      key: client.id,
      attrs: {
        value: client.id,
        label: client.name
      }
    });
  }), 1)], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Client Contact",
      prop: "clientsContactId"
    }
  }, [_c("div", {
    staticClass: "input-with-action",
    staticStyle: {
      display: "flex",
      gap: "8px"
    }
  }, [_c("el-select", {
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      disabled: !_vm.formData.clientId || _vm.isEdit,
      filterable: "",
      placeholder: "Select Contact"
    },
    on: {
      change: _vm.onContactChange
    },
    model: {
      value: _vm.formData.clientsContactId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "clientsContactId", $$v);
      },
      expression: "formData.clientsContactId"
    }
  }, _vm._l(_vm.contactList, function (contact) {
    return _c("el-option", {
      key: contact.id,
      attrs: {
        label: contact.firstName + " " + contact.lastName,
        value: contact.id
      }
    });
  }), 1), !_vm.isEdit ? _c("el-button", {
    staticClass: "add-btn",
    attrs: {
      disabled: !_vm.formData.clientId,
      type: "primary",
      size: "small",
      icon: "el-icon-plus",
      circle: ""
    },
    on: {
      click: _vm.tootgleContactDialog
    }
  }) : _vm._e()], 1)])], 1), _c("div", {
    staticClass: "form-section"
  }, [_c("div", {
    staticClass: "form-section__label"
  }, [_vm._v(" Sales Team ")]), _c("el-row", {
    attrs: {
      gutter: 16
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Sales Manager",
      prop: "salesManagerId"
    }
  }, [_vm.loggedInAdmin ? _c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      placeholder: "Select Manager",
      disabled: ""
    },
    on: {
      change: _vm.selectCordinator
    },
    model: {
      value: _vm.formData.salesManagerId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "salesManagerId", $$v);
      },
      expression: "formData.salesManagerId"
    }
  }, _vm._l(_vm.managerList, function (admin) {
    return _c("el-option", {
      key: admin.id,
      attrs: {
        label: admin.fullName,
        value: admin.id
      }
    });
  }), 1) : _vm._e()], 1)], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Sales Coordinator",
      prop: "salesCoordinatorId"
    }
  }, [_vm.loggedInAdmin ? _c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      placeholder: "Select Coordinator",
      disabled: _vm.isEdit
    },
    model: {
      value: _vm.formData.salesCoordinatorId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "salesCoordinatorId", $$v);
      },
      expression: "formData.salesCoordinatorId"
    }
  }, _vm._l(_vm.coordinatorList, function (admin) {
    return _c("el-option", {
      key: admin.id,
      attrs: {
        label: admin.fullName,
        value: admin.id
      }
    });
  }), 1) : _vm._e()], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "form-section"
  }, [_c("div", {
    staticClass: "form-section__label"
  }, [_vm._v(" Lead Details ")]), _c("el-row", {
    attrs: {
      gutter: 16
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Client Reference",
      prop: "prNumber"
    }
  }, [_c("el-input", {
    attrs: {
      type: "text",
      placeholder: "Enter Client Reference",
      disabled: _vm.isEdit
    },
    model: {
      value: _vm.formData.prNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "prNumber", $$v);
      },
      expression: "formData.prNumber"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Source",
      prop: "sourceId"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      disabled: _vm.isEdit,
      placeholder: "Select Source"
    },
    model: {
      value: _vm.formData.sourceId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "sourceId", $$v);
      },
      expression: "formData.sourceId"
    }
  }, _vm._l(_vm.sourceList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 16
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_vm.formData.productAction === "Send Options" ? _c("el-form-item", {
    attrs: {
      label: "Total Budget (₹)",
      prop: "budgetPerPiece"
    }
  }, [_c("el-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      precision: 2,
      controls: true
    },
    on: {
      change: _vm.setInquiryCategorization
    },
    model: {
      value: _vm.formData.budgetPerPiece,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "budgetPerPiece", $$v);
      },
      expression: "formData.budgetPerPiece"
    }
  })], 1) : _vm._e(), _vm.formData.productAction === "Sourcing" ? _c("el-form-item", {
    attrs: {
      label: "Tentative Budget Per Piece (₹)",
      prop: "budgetPerPiece"
    }
  }, [_c("el-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 1,
      step: 10,
      precision: 2,
      controls: false
    },
    on: {
      change: _vm.setInquiryCategorization
    },
    model: {
      value: _vm.formData.budgetPerPiece,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "budgetPerPiece", $$v);
      },
      expression: "formData.budgetPerPiece"
    }
  })], 1) : _vm._e()], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Quantity",
      prop: "quantity"
    }
  }, [_c("el-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 1,
      step: 1,
      "step-strictly": "",
      disabled: _vm.isEdit
    },
    on: {
      change: _vm.setInquiryCategorization
    },
    model: {
      value: _vm.formData.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "quantity", $$v);
      },
      expression: "formData.quantity"
    }
  })], 1)], 1)], 1), _vm.formData.productAction === "Send Quote" ? _c("el-form-item", {
    attrs: {
      label: "Select Products",
      prop: "selectedProduct"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "remote-method": _vm.fetchProducts,
      multiple: "",
      filterable: "",
      clearable: "",
      remote: "",
      placeholder: "Search Product (min. 3 chars)",
      disabled: _vm.isEdit
    },
    model: {
      value: _vm.selectedProduct,
      callback: function ($$v) {
        _vm.selectedProduct = $$v;
      },
      expression: "selectedProduct"
    }
  }, _vm._l(_vm.productList, function (product) {
    return _c("el-option", {
      key: product.id,
      attrs: {
        value: product.id,
        label: product.name,
        disabled: product.unitPrice < 1
      }
    }, [_c("template", {
      slot: "default"
    }, [product.product.productsImage.length ? _c("img", {
      staticClass: "product-thumb",
      attrs: {
        src: product.product.productsImage[0].image + "-md"
      }
    }) : _vm._e(), _c("span", [_vm._v(_vm._s(product.name))])])], 2);
  }), 1)], 1) : _vm._e(), _vm.formData.productAction === "Sourcing" ? _c("el-form-item", {
    attrs: {
      label: "Product Name",
      prop: "productName"
    }
  }, [_c("el-input", {
    attrs: {
      type: "text",
      disabled: _vm.isEdit
    },
    model: {
      value: _vm.formData.sourcingProductName,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "sourcingProductName", $$v);
      },
      expression: "formData.sourcingProductName"
    }
  })], 1) : _vm._e(), _vm.formData.productAction === "Sourcing" ? _c("el-form-item", {
    attrs: {
      label: "Product Image",
      prop: "productImage"
    }
  }, [_c("file-upload", {
    attrs: {
      url: "/common/upload",
      field: "file",
      accept: ".jpg, .jpeg, .png",
      "max-size": 10,
      "file-list": _vm.sourceProductImage,
      multiple: true,
      disabled: _vm.isEdit
    },
    on: {
      change: _vm.handleImageUpload
    }
  })], 1) : _vm._e(), _c("el-row", {
    attrs: {
      gutter: 16
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Tentative Delivery (days)",
      prop: "tentativeDeliveryDuration"
    }
  }, [_c("el-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 1,
      step: 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.formData.tentativeDeliveryDuration,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "tentativeDeliveryDuration", $$v);
      },
      expression: "formData.tentativeDeliveryDuration"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Expected Closure",
      prop: "expectedClosureDate"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      format: "dd-MM-yyyy",
      "picker-options": _vm.pickerOptions,
      disabled: _vm.isEdit
    },
    model: {
      value: _vm.formData.expectedClosureDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "expectedClosureDate", $$v);
      },
      expression: "formData.expectedClosureDate"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Comments",
      prop: "comments"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      placeholder: "Add any relevant notes…"
    },
    model: {
      value: _vm.formData.comments,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "comments", $$v);
      },
      expression: "formData.comments"
    }
  })], 1)], 1), _c("div", {
    staticClass: "form-footer"
  }, [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "submit-btn",
    attrs: {
      loading: _vm.loading,
      type: "primary"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_c("i", {
    staticClass: "el-icon-check"
  }), _vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")])], 1)])], 1), _c("el-dialog", {
    attrs: {
      title: "Add Contact",
      visible: _vm.contactDialogVisible,
      "destroy-on-close": true,
      "custom-class": "responsive-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.contactDialogVisible = $event;
      }
    }
  }, [_c("clients-contact-detail", {
    ref: "contactFormRef",
    attrs: {
      "client-id": _vm.formData.clientId
    },
    on: {
      saved: function ($event) {
        return _vm.refresh($event);
      }
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "Add Concept",
      visible: _vm.conceptDialogVisible,
      "destroy-on-close": true,
      "custom-class": "responsive-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.conceptDialogVisible = $event;
      }
    }
  }, [_c("concept-detail", {
    ref: "contactFormRef",
    attrs: {
      "redirect-to-list": false
    },
    on: {
      saved: function ($event) {
        return _vm.refresh($event);
      }
    }
  })], 1)], 1), _c("el-col", {
    staticClass: "recent-inquiries-col",
    attrs: {
      xs: 24,
      lg: 10
    }
  }, [_c("div", {
    staticClass: "leads-card"
  }, [_c("div", {
    staticClass: "leads-card__header"
  }, [_c("div", {
    staticClass: "header-info"
  }, [_c("h3", {
    staticClass: "leads-card__title"
  }, [_vm._v(" Recent Lead ")]), _c("p", {
    staticClass: "leads-card__subtitle"
  }, [_vm._v(" Last activity for this client ")])]), _vm.recentLeads.length && _vm.leadStatusCount ? _c("div", {
    staticClass: "leads-card__stats"
  }, [_c("span", {
    staticClass: "stat-badge stat-badge--won"
  }, [_c("i", {
    staticClass: "el-icon-trophy"
  }), _vm._v(" " + _vm._s(_vm.leadStatusCount.Won) + " Won ")]), _c("span", {
    staticClass: "stat-badge stat-badge--lost"
  }, [_c("i", {
    staticClass: "el-icon-close"
  }), _vm._v(" " + _vm._s(_vm.leadStatusCount.Lost) + " Lost ")])]) : _vm._e()]), _c("div", {
    staticClass: "leads-list"
  }, _vm._l(_vm.recentLeads, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "lead-item"
    }, [_c("div", {
      staticClass: "lead-item__top"
    }, [_c("div", {
      staticClass: "lead-contact"
    }, [_c("h4", {
      staticClass: "contact-name lead-id-link",
      on: {
        click: function ($event) {
          return _vm.$router.push("/follow-ups/list/" + item.id);
        }
      }
    }, [_c("i", {
      staticClass: "el-icon-document"
    }), _vm._v(" #" + _vm._s(item.id) + " "), item.client && item.client.name ? _c("span", {
      staticClass: "lead-pr-number"
    }, [_vm._v(" — " + _vm._s(item.client.name))]) : _vm._e()]), _c("div", {
      staticClass: "contact-details"
    }, [item.clientsContact && item.clientsContact.firstName ? _c("span", {
      staticClass: "contact-link"
    }, [_c("i", {
      staticClass: "el-icon-user-solid"
    }), _vm._v(" " + _vm._s(item.clientsContact.firstName) + " " + _vm._s(item.clientsContact.lastName) + " ")]) : _vm._e(), item.clientsContact && item.clientsContact.designation ? _c("span", {
      staticClass: "contact-link"
    }, [_c("i", {
      staticClass: "el-icon-s-custom"
    }), _vm._v(" " + _vm._s(item.clientsContact.designation) + " ")]) : _vm._e()])]), _c("div", {
      staticClass: "lead-financials"
    }, [_c("div", {
      staticClass: "lead-grand-total"
    }, [_c("span", {
      staticClass: "lead-grand-total__label"
    }, [_vm._v("Grand Total")]), _c("span", {
      staticClass: "lead-grand-total__value"
    }, [_vm._v("₹" + _vm._s(item.grandTotal))])])])]), _c("div", {
      staticClass: "lead-item__meta"
    }, [_c("div", {
      staticClass: "meta-box"
    }, [_c("span", {
      staticClass: "meta-label"
    }, [_vm._v("Expected Closure")]), _c("span", {
      staticClass: "meta-value"
    }, [_c("i", {
      staticClass: "el-icon-date"
    }), _vm._v(" " + _vm._s(_vm._f("moment")(item.expectedClosureDate, "DD MMM YYYY")) + " ")])]), _c("div", {
      staticClass: "meta-box"
    }, [_c("span", {
      staticClass: "meta-label"
    }, [_vm._v("Created At")]), _c("span", {
      staticClass: "meta-value"
    }, [_c("i", {
      staticClass: "el-icon-time"
    }), _vm._v(" " + _vm._s(_vm._f("moment")(item.createdTimestamp, "DD MMM YYYY")) + " ")])])]), _c("div", {
      staticClass: "lead-item__footer"
    }, [_c("div", {
      staticClass: "team-group"
    }, [_c("div", {
      staticClass: "team-member-row"
    }, [_c("div", {
      staticClass: "team-avatar avatar-coord"
    }, [_vm._v(" " + _vm._s(item.salesCoordinator.fullName.charAt(0)) + " ")]), _c("div", {
      staticClass: "team-member-info"
    }, [_c("span", {
      staticClass: "team-role"
    }, [_vm._v("Coordinator")]), _c("span", {
      staticClass: "team-name"
    }, [_vm._v(_vm._s(item.salesCoordinator.fullName))])])]), _c("div", {
      staticClass: "team-member-row"
    }, [_c("div", {
      staticClass: "team-avatar avatar-mgr"
    }, [_vm._v(" " + _vm._s(item.salesManager.fullName.charAt(0)) + " ")]), _c("div", {
      staticClass: "team-member-info"
    }, [_c("span", {
      staticClass: "team-role"
    }, [_vm._v("Manager")]), _c("span", {
      staticClass: "team-name"
    }, [_vm._v(_vm._s(item.salesManager.fullName))])])])]), _c("el-tag", {
      class: ["lead-status", "lead-status--" + item.status.toLowerCase()],
      attrs: {
        size: "small",
        effect: "dark"
      }
    }, [_vm._v(" " + _vm._s(item.status) + " ")])], 1)]);
  }), 0)])])], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;